export default defineNuxtRouteMiddleware((to) => {
  const user = useSupabaseUser();
  const hasDeleteToken = !!to.query.delete_token;

  // Cho phép: đã đăng nhập HOẶC đang trong luồng xác nhận xóa tài khoản qua email
  if (!user.value && !hasDeleteToken) {
    return navigateTo("/auth");
  }
});
